import { type SuggestedAction } from '../../../../types/ai';
import { cn } from '../../../../utils/cn';
import { isProductSelectAction } from '../actions/product-actions';

export const SuggestedActions = ({
  actions,
  onActionClick,
  hideExternalLinks = false,
}: {
  actions: SuggestedAction[];
  onActionClick: (action: SuggestedAction) => void;
  hideExternalLinks?: boolean;
}) => {
  const displayActions = actions.filter(
    (a) =>
      !String(a.value).startsWith('outfit_change:') &&
      !String(a.value).startsWith('outfit_select:') &&
      !isProductSelectAction(a) &&
      (!hideExternalLinks || !String(a.externalUrl ?? '').trim()) &&
      !/^jag[\s\S]{0,10}v[\s\S]{0,5}ljer?\s+/i.test(String(a.value)),
  );
  if (!displayActions || displayActions.length === 0) return null;

  const getActionLabel = (action: SuggestedAction) => {
    const rawLabel = String(action.label ?? '').trim();
    const rawValue = String(action.value ?? '').trim();

    if (/^outfit_change:/i.test(rawLabel)) {
      const match = rawValue.match(/^outfit_change:(.+)$/i);
      if (match?.[1]) {
        return `Byt ${match[1].trim().replace(/[_-]+/g, ' ')}`;
      }
    }

    if (!rawLabel && /^outfit_change:/i.test(rawValue)) {
      const match = rawValue.match(/^outfit_change:(.+)$/i);
      if (match?.[1]) {
        return `Byt ${match[1].trim().replace(/[_-]+/g, ' ')}`;
      }
    }

    return rawLabel || rawValue;
  };

  const getActionClasses = (action: SuggestedAction) => {
    const value = String(action.value ?? '').toLowerCase();

    if (value.startsWith('outfit_change:')) {
      return 'border-brand-blue bg-brand-blue text-white hover:bg-white hover:text-brand-blue';
    }

    if (value.includes('helt ny komplett outfit') || value.includes('ny komplett outfit')) {
      return 'border-slate-900 bg-slate-900 text-white hover:bg-white hover:text-slate-900';
    }

    return 'border-brand-blue bg-white text-brand-blue hover:bg-brand-blue hover:text-white';
  };

  return (
    <div className="mt-1.5 flex flex-wrap gap-2">
      {displayActions.map((action, index) => {
        const externalUrl = String(action.externalUrl ?? '').trim();
        const className = cn(
          'rounded-sm border px-3.5 py-2 text-sm transition-colors duration-200',
          getActionClasses(action),
        );

        if (externalUrl) {
          return (
            <a
              key={index}
              href={externalUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={className}
            >
              {getActionLabel(action)}
            </a>
          );
        }

        return (
          <button
            key={index}
            type="button"
            onClick={() => onActionClick(action)}
            className={className}
          >
            {getActionLabel(action)}
          </button>
        );
      })}
    </div>
  );
};
